import React from "react";

import { SingleJob, SingleCompany } from "interfaces/api/apiInterfaces";
import { JobTrackingProps, museTrack } from "utils/tracking";

import styles from "./JobIndividualSidebar.module.scss";

const SearchLink = (props: { href: string, displayText: string, onClick: () => void }) => {
    const { href, displayText, onClick } = props;

    return (
        <a target="_blank" href={href} onClick={onClick}>{displayText}</a>
    );
};

export const SuggestedSearchesSidebarModule = (props: {
    job: SingleJob, company: SingleCompany, museWebHost: string, trackingProps: JobTrackingProps,
}) => {
    const {
        job,
        company,
        museWebHost,
        trackingProps,
    } = props;
    const trackLinkClick = (placementPosition: number, suggestedSearchType: string) => {
        museTrack("Jobs Individual Link Clicked", {
            ...trackingProps,
            placement_position: placementPosition,
            click_origin: `suggested_search_${suggestedSearchType}`
        });
    };
    let suggestedSearchLinks = [
        {
            suggestedSearchType: "level",
            href: `${museWebHost}/search/level/${job?.levels[0]?.value}`,
            displayText: `${job?.levels[0]?.display} jobs`,
            active: !!job?.levels?.length
        },
        {
            suggestedSearchType: "company",
            href: `${museWebHost}/hiring/company/${company?.short_name}`,
            displayText: `${company?.name} jobs`,
            active: true
        },
        {
            suggestedSearchType: "alljobs",
            href: `${museWebHost}/hiring`,
            displayText: "All jobs",
            active: true
        },
    ];
    const category = job?.categories[0];
    if (category?.value.toLowerCase() !== "unknown") {
        suggestedSearchLinks = [
            {
                suggestedSearchType: "category",
                href: `${museWebHost}/hiring/category/${category?.code}`,
                displayText: `${category?.value} jobs`,
                active: !!job?.categories?.length
            },
            ...suggestedSearchLinks
        ];
    }

    return (
        <div className={styles.suggestedSearchesModule}>
            <h2>Suggested Searches</h2>
            <ul>
                { suggestedSearchLinks.map((searchLink, index) => searchLink.active ? (
                    <li key={`suggested-search-link-${searchLink.suggestedSearchType}`}>
                        <SearchLink
                            href={searchLink.href}
                            displayText={searchLink.displayText}
                            onClick={() => {
                                trackLinkClick(index + 1, searchLink.suggestedSearchType);
                            }}
                        />
                    </li>
                ) : null) }
            </ul>
        </div>
    );
};
